import dayjs from 'dayjs';

import { COMMON_DATE_FORMAT } from 'constants/date';
import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { fundingInformationTypeOptions } from 'constants/options';

import { LoanClosingTestIds } from '../LoanClosing.testIds';

export const fundingInformationEditConfigFields = {
  fundingInfoWarehouseBankId: {
    fieldId: 'fundingInfoWarehouseBankId',
    type: FieldType.SELECT,
    nameInModel: 'fundingInfoWarehouseBankId',
    inputProps: {
      label: 'Warehouse Bank',
      variant: 'outlined',
      options: [],
    },
  },
  commitmentNumber: {
    fieldId: 'commitmentNumber',
    type: FieldType.INPUT,
    nameInModel: 'commitmentNumber',
    inputProps: {
      label: 'Commitment #',
      variant: 'outlined',
      type: FieldInputType.TEXT_EXCEPT_SPECIAL_SYMBOLS,
      required: false,
    },
  },
  type: {
    fieldId: 'type',
    type: FieldType.SELECT,
    nameInModel: 'type',
    inputProps: {
      label: 'Type',
      variant: 'outlined',
      options: fundingInformationTypeOptions,
      disabled: true,
    },
  },
  fundingConfirmationNumber: {
    fieldId: 'fundingConfirmationNumber',
    type: FieldType.INPUT,
    nameInModel: 'fundingConfirmationNumber',
    inputProps: {
      label: 'Funding Confirmation Number',
      required: false,
      variant: 'outlined',
      type: FieldInputType.TEXT,
    },
  },
  fundingInfoWireAmount: {
    fieldId: 'fundingInfoWireAmount',
    type: FieldType.INPUT,
    nameInModel: 'fundingInfoWireAmount',
    inputProps: {
      label: 'Wire Amount',
      variant: 'outlined',
      type: FieldInputType.CURRENCY,
      required: false,
    },
  },
  wireComments: {
    fieldId: 'wireComments',
    type: FieldType.INPUT,
    nameInModel: 'wireComments',
    inputProps: {
      label: 'Wire Comments',
      variant: 'outlined',
      type: FieldInputType.TEXT_EXCEPT_SPECIAL_SYMBOLS,
      required: false,
      multiline: true,
      rows: 3,
      maxLength: 500,
      widthInColumns: 4,
    },
  },
  wirePostedDate: {
    fieldId: 'wirePostedDate',
    type: FieldType.DATE,
    nameInModel: 'wirePostedDate',
    inputProps: {
      label: 'Wire Posted Date',
      variant: 'outlined',
      format: COMMON_DATE_FORMAT,
      includeLocalOffset: true,
      dataTestId: LoanClosingTestIds.FUNDING_INFORMATION_FORM_WIRE_POSTED_DATE_INPUT,
      'data-test-value': dayjs(),
    },
  },
  curtailment: {
    fieldId: 'curtailment',
    type: FieldType.INPUT,
    nameInModel: 'curtailment',
    inputProps: {
      label: 'Curtailment',
      variant: 'outlined',
      type: FieldInputType.TEXT_EXCEPT_SPECIAL_SYMBOLS,
      required: false,
    },
  },
  warehouseFundingOrdered: {
    fieldId: 'warehouseFundingOrdered',
    type: FieldType.DATE,
    nameInModel: 'warehouseFundingOrdered',
    inputProps: {
      label: 'Warehouse Funding Ordered',
      variant: 'outlined',
      format: COMMON_DATE_FORMAT,
      includeLocalOffset: true,
      dataTestId: LoanClosingTestIds.FUNDING_INFORMATION_FORM_FUNDING_ORDERED_INPUT,
      'data-test-value': dayjs(),
    },
  },
};
